export default "__VITE_ASSET__00f7cb83__"